export default __webpack_public_path__ + "app/components/uiSelect/backendMultipleUISelect.html";